import { CmsAsset } from './CmsAsset';

type CmsAssetsProps = {
  assetIds: string[];
};

export const CmsAssets = ({ assetIds }: CmsAssetsProps) => {
  return (
    <>
      {assetIds.map(id => (
        <CmsAsset entityId={id} key={`attachment_${id}`} />
      ))}
    </>
  );
};
